import { OPTIONS_TYPE } from '@/enums';
import { deepMerge } from '@/utils';
import { getCreativeConfig } from '@/views/fusion/investment/intelligence-create/model/form';

export default (s) => {
  const basic_form_fields = {
    base_form: {
      config: getCreativeConfig([
        'creative_name',
      ]),
    },
  };

  const form_fields = {
    base_form: {
      config: {
        creative_name: {
          props: {
            disabled: true,
          },
          rules: {
            require: false,
          },
        },
      },
    },
    creative_message: {
      config: {
        material: {
          label: '素材',
          hidden: false,
          props: {
            tempMaterial: null,
          },
          value: {
            images: [],
            videos: [],
            tab: 'video',
          },
        },
        titles: {
          label: '标题',
          hidden: false,
          value: [],
        },
        sites: {
          label: '落地页',
          hidden: false,
          value: [],
        },
      },
    },
    creative_price: {
      title: '创意出价',
      config: {
        budget_selection: {
          label: '创意预算',
          type: 'radio-group',
          hidden: true,
          isButton: true,
          options: [
            { label: '指定预算', value: OPTIONS_TYPE.CUSTOM },
          ],
          value: OPTIONS_TYPE.CUSTOM,
        },
        budget: {
          label: ' ',
          type: 'input-number',
          hidden: true,
          props: {
            step: 1,
            precision: 2,
            min: 300,
            max: 9999999.99,
          },
          formItemTips: {
            props: {
              class: 'inline-block',
              style: {
                marginLeft: '10px',
              },
            },
            content: '元',
          },
          value: undefined,
          rules: { required: true, message: '请输入创意日预算', trigger: ['change'] },
        },
        cpa_bid: {
          label: '优化目标出价',
          type: 'input-number',
          hidden: true,
          props: {
            step: 1,
            precision: 2,
            min: 0.01,
            max: 999999999.00,
          },
          formItemTips: {
            props: {
              class: 'inline-block',
              style: {
                marginLeft: '10px',
              },
            },
            content: '元',
          },
          value: undefined,
          rules: { required: true, message: '请输入优化目标出价', trigger: ['change'] },
        },
        deep_cpabid: {
          label: '深度优化出价',
          type: 'input-number',
          hidden: true,
          props: {
            step: 1,
            precision: 2,
            min: 0.01,
            max: 999999999.00,
          },
          formItemTips: {
            props: {
              class: 'inline-block',
              style: {
                marginLeft: '10px',
              },
            },
            content: '元',
          },
          value: undefined,
          rules: { required: true, message: '请输入深度优化出价', trigger: ['change'] },
        },
        roi_goal: {
          label: '深度ROI系数出价',
          type: 'input-number',
          hidden: true,
          props: {
            step: 1,
            precision: 3,
            min: 0.001,
            max: 1000,
          },
          value: undefined,
          rules: { required: true, message: '请输入深度ROI系数出价', trigger: ['change'] },
        },
        first_roi_goal: {
          label: '首日ROI系数出价',
          type: 'input-number',
          hidden: true,
          props: {
            step: 1,
            precision: 3,
            min: 0.001,
            max: 1000,
          },
          value: undefined,
          rules: { required: true, message: '请输入深度ROI系数出价', trigger: ['change'] },
        },
      },
    },
  };

  return deepMerge([basic_form_fields, form_fields]);
};
